import React from 'react'
import StoreForm from '../../components/Stores/StoreForm'


const ReSubmitStore = () => {
  return (
    <StoreForm mode="Resubmit"/>
  )
}

export default ReSubmitStore